module.exports = __webpack_public_path__ + "static/20230619_176-dd6589d1c9729fc8302436b0da96f331.jpg";